<template>
  <div class="loader-bar-wrapper">
    <transition name="fadeBar">
      <div class="loader-bar" v-if="preloaderBarShow">
        <div class="loader-bar__bar" :class="animateClass"></div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    computed: {
      ...mapState('appInterface', [
        'preloaderBarShow'
      ]),
      // preloaderBarShow: self => self.$store.state.appInterface.preloaderBarShow,
      animateClass () {
        return this.preloaderBarShow ? 'animate' : ''
      }
    }
  }
</script>

<style lang="scss">
.loader-bar-wrapper{
  .loader-bar{
    position: relative;
    height: 3px;
    background: #DCDFE5;
    margin-bottom: -3px;
    z-index: 101;
    &__bar{
      position: absolute;
      background: #1989FA;
      width: 200px;
      height: 3px;
      left: -150px;
      &.animate{
        // animation: cubic-bezier(0,0,.58,1) barLoad 1.5s infinite;
        animation: cubic-bezier(0,0,.58,1) barLoad 2.5s infinite;
      }
    }
  }
  .fadeBar-enter, .fadeBar-enter-active{
    opacity: 0;
    transition: opacity .3s cubic-bezier(.25,.1,.25,1);
  }
  .fadeBar-enter-to{
    opacity: 1;
  }
  .fadeBar-leave-to {
    opacity: 0;
    transition: opacity .5s cubic-bezier(.25,.1,.25,1);
  }
}
@keyframes barLoad {
  0%{
    left: -150px;
  }
  50%{
    left: calc(100% - 50px);
  }
  100%{
    left: -150px;
  }
}
</style>